<template>
  <TableGroup
    :table-title="tableTitle"
    modal-title="Создать ЦМК"
    namespaced="pto/project/pto/cmk"
    :rights-all="$store.getters.rightsPtoAll"
    :init-filter="initFilter"
    :add-to-post-data="initFilter"
    post-data-has-files
  >
    <template v-slot:modalForm="props">
      <FormPtoProjectPtoCMK
        :is-sending="props.isSendingRequest"
        @request="props.createSubmit"
        @cancel="props.closeModal"
      />
    </template>
  </TableGroup>
</template>

<script>
import FormPtoProjectPtoCMK from '@/components/pto/form/FormPtoProjectPtoCMK'
import TableGroup from '@/components/page/TableGroup'

import { mapGetters } from 'vuex'

export default {
  name: 'PtoProjectPtoCMK',
  components: {
    FormPtoProjectPtoCMK,
    TableGroup
  },

  computed: {
    ...mapGetters('pto/project', {
      currentProject: 'getCurrentItem',
      initFilter: 'getChildrenFilter'
    }),
    tableTitle () {
      return 'ЦМК по проекту ' + this.currentProject?.name
    }
  }
}
</script>
